export interface IAuth {
  token: string;
  refreshToken: string;
  mustSetPassword?: boolean;
}
